function a(c, n, o) {
  const e = document.createElement("script");
  e.onload = o, e.id = n, e.src = c, document.head.appendChild(e);
}
function i(c, n) {
  return new Promise((o, e) => {
    const d = n || document, t = d.createElement("script");
    t.src = c, t.onload = (r) => o(r), t.onerror = (r) => e(r), d.head.appendChild(t);
  });
}
export {
  a as default,
  i as loadScriptAsync
};
